import React from "react";
import { HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/**
 * Help button with tooltip
 */
export const HelpTooltip = React.memo(({
  text,
  ariaLabel
}: {
  text: string;
  ariaLabel?: string;
}) => {
  return <Popover>
                <PopoverTrigger asChild>
                    <Button variant="ghost" type="button" aria-label={ariaLabel} className="text-gray-300 hover:text-white !px-0 md:!px-2 !py-0 hover:!bg-sky-900/40 !rounded-full transition-all duration-200 w-4 h-4 md:w-8 md:h-8 flex items-center justify-center">
                        <HelpCircle className="h-4 w-4 text-sky-400 cursor-help hover:text-sky-300 transition-colors" />
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="!rounded-xl border !border-slate-700/30 !bg-gradient-to-b from-slate-800 to-slate-900 p-3 max-w-[250px] sm:max-w-[300px] shadow-lg shadow-slate-900/40">
                    <p className="text-sm text-slate-300 leading-relaxed">
                        {text}
                    </p>
                </PopoverContent>
            </Popover>;
});
HelpTooltip.displayName = "HelpTooltip";